import { createSelector } from '@ngrx/store';

import { SoccerClub } from '../../models/soccerClub';
import { AppState } from '../states/app.state';

const selectClubState = (state: AppState) => state.clubs;

export const getClub = createSelector(selectClubState, (state: SoccerClub) => state);
